/* import __COLOCATED_TEMPLATE__ from './translations-list-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class TranslationsListCardComponent extends Component 
{
	@service store;
	
	@tracked isAddingNewTranslation = false;
	
	@tracked newChipBib = "";
	@tracked newChipName = "";
	@tracked newChipChip = "";
	
	@action
	deleteTranslation(translation)
	{
		translation.deleteRecord();
		translation.save();
	}
	
	@action
	saveNew()
	{
		this.store.createRecord('translation', 
		{
			name:this.newChipName,
			bib: this.newChipBib,
			chip: this.newChipChip,
			lot: "0"
		}).save();
		
		this.isAddingNewTranslation = false;
		this.newChipBib = "";
		this.newChipName = "";
		this.newChipChip = "";
	};
	
	@action
	cancelNew()
	{
		this.isAddingNewTranslation = false;
		this.newChipBib = "";
		this.newChipName = "";
		this.newChipChip = "";
	};
};